//import Image, { type ImageProps } from 'next/image';
import { classNames } from 'primereact/utils';
import type { ImgHTMLAttributes, ReactNode } from 'react';
import style from './tier-banner.module.css';

type Props = {
	content: ReactNode;
	className?: string;
	image?: ImgHTMLAttributes<HTMLImageElement>;
};

const TierBanner = (props: Props) => {
	const { content, className, image } = props;
	return (
		<div className={classNames(style.tierBanner, className)}>
			{image && <img {...image} />}
			{content}
		</div>
	);
};

export default TierBanner;
